import { useAuth0 } from '@auth0/auth0-react';
import { Loader } from '@mantine/core';
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ADMIN_ROLE } from '../magic-values';
import { useCurrentUser } from '../queries/use-current-user';
import { CenteredLayout } from './centered-layout';
import { UnauthorizedMessage } from './unauthorized-message';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();
  const from = location.pathname + location.search + location.hash;
  const { data: currentUser, isError } = useCurrentUser();
  const isAdmin = currentUser?.role === ADMIN_ROLE;

  // Branch order matters: "still resolving" must not fall through to the
  // unauthorized screen, or it flashes on every load.
  return isLoading ? (
    <CenteredLayout>
      <Loader />
    </CenteredLayout>
  ) : !isAuthenticated ? (
    <Navigate to="/login" state={{ from }} replace />
  ) : isAdmin ? (
    <>{children}</>
  ) : currentUser || isError ? (
    <UnauthorizedMessage />
  ) : (
    <CenteredLayout>
      <Loader />
    </CenteredLayout>
  );
}
